import React from "react";
import "../styles/Impressum.css";



const Impressum = () => {
  return (
    <div className="impressum-container">
      <h1>Impressum</h1>
      <p><strong>Angaben gemäß § 5 TMG:</strong></p>
      <p>
       Satheevan Kasippillai<br />
        Am Wamershof 23<br />
        47804 Krefeld<br />
      </p>
      <p><strong>Vertreten durch: </strong><br />
        Satheevan Kasippillai
      </p>
      <p><strong>Kontakt:</strong><br />
        Telefon: oo49+16264I68366<br />
        E-Mail:team(at)checkideas.com
      </p>
      <p><strong>Registereintrag:</strong><br />
        Eintragung im Handelsregister.<br />
        Registergericht: [Name des Registergerichts]<br />
        Registernummer: [Handelsregisternummer]
      </p>
      <p><strong>Umsatzsteuer-ID:</strong><br />
        Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
        [Ihre Umsatzsteuer-ID]
      </p>
      <p><strong>Inhaltlich Verantwortlicher gemäß § 55 Abs. 2 RStV:</strong><br />
        [Name der verantwortlichen Person]<br />
        [Anschrift wie oben]
      </p>
      <p><strong>Haftungsausschluss:</strong></p>
      <p><strong>Haftung für Inhalte</strong></p>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>
      <p>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
      </p>
      <p><strong>Haftung für Links</strong></p>
      <p>
        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
      </p>
      <p>
        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </p>
      <p><strong>Urheberrecht</strong></p>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
      </p>
      <p>
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </p>
    </div>
  );
};

export default Impressum;
